<template>
    <b-card
        :title="translations.addExternalLink[lang]"
        :loading="loading"
        :error-message="errorMessage"
        @cancel="$emit('cancel')"
        @submit="addExternalLink()"
        :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
        :cancel-text="{ el: 'Ακύρωση', en: 'Cancel', it: 'Cancella' }"
    >
        <v-file-input
            v-model="uploadingImage"
            color="secondary"
            :label="translations.image[lang]"
            outlined
            dense
            hide-details="auto"
        ></v-file-input>

        <b-text-field
            v-model="externalLink.url"
            :label="translations.link[lang]"
            class="mt-3"
        ></b-text-field>
    </b-card>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import translations from "@/utils/translations/storePanel/products/externalLinks";

export default {
    name: "ExternalLinkForm",

    props: {
        mode: Number,
    },

    data: () => ({}),

    mixins: [translations],

    computed: {
        ...mapState([
            "loading",
            "errorMessage",
            "resetSuccess",
            "resetValidation",
        ]),

        lang() {
            return this.$route.params.lang;
        },

        externalLink: {
            get() {
                return this.$store.state.storePanel.externalLinks.externalLink;
            },

            set(val) {
                this.setExternalLink(val);
            },
        },

        uploadingImage: {
            get() {
                return this.$store.state.storePanel.externalLinks
                    .uploadingImage;
            },

            set(val) {
                this.setUploadingImage(val);
            },
        },
    },

    methods: {
        ...mapMutations("storePanel/externalLinks", [
            "setExternalLink",
            "setUploadingImage",
        ]),
        ...mapActions("storePanel/externalLinks", ["addExternalLink"]),
    },
};
</script>
